import { useMemo, useState, useEffect, useRef } from 'react';
import { getCampaignNameValidationError } from '../utils/campaignName';
const DEBOUNCE_TIME = 500;
export function getCanCampaignNameBeSaved(name) {
  return !!name.trim() && !getCampaignNameValidationError(name);
}
export default function useCampaignNameValidation(name = '', customValidationMessages) {
  const timeoutId = useRef(undefined);
  const [campaignNameValidationError, setCampaignNameValidationError] = useState(getCampaignNameValidationError(name, customValidationMessages));
  useEffect(() => {
    clearTimeout(timeoutId.current);
    timeoutId.current = setTimeout(() => {
      setCampaignNameValidationError(getCampaignNameValidationError(name, customValidationMessages));
    }, DEBOUNCE_TIME);
    return () => {
      clearTimeout(timeoutId.current);
    };
  }, [name, customValidationMessages]);
  return useMemo(() => ({
    canCampaignNameBeSaved: name !== '' && !campaignNameValidationError,
    isCampaignNameValid: !campaignNameValidationError,
    campaignNameValidationError
  }), [name, campaignNameValidationError]);
}